import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef, Inject, ViewChild, SimpleChanges, OnChanges, EmbeddedViewRef, ViewContainerRef, TemplateRef, Directive } from '@angular/core';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'app-rapport',
    templateUrl: './rapport.component.html',
    styleUrls: ['./rapport.component.scss', '../../rapports.scss']
})
export class RapportComponent implements OnInit {
    
    subscribe: any = [];
    messageError: string = "";
    nodeid: string = "cobhamjsexjs";
    rapport: any;
    fragments: any;
    name: any;
    
    viewRef: EmbeddedViewRef<any>;

    @Input() nameRapport : string;
    @Input() dossier : any;
    @Input() precharge : any;

    constructor(
        private appService: AppService,
        private cdf: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        if ((<HTMLElement> document.getElementById(this.nodeid)))
            (<HTMLElement> document.getElementById(this.nodeid)).remove()
        
        if (this.precharge) {
            this.afficherRapport(this.precharge);
        } else if (this.dossier && this.dossier.id && this.nameRapport) {
            if(this.subscribe['rapport']){
                this.subscribe['rapport'].unsubscribe()
            }    
            this.subscribe['rapport'] = this.appService.rapport(this.dossier.id, this.nameRapport, false).subscribe((res) => {
                if(res && res['result']){
                    this.afficherRapport(res['result']);
                }
            });
        }
    }

    afficherRapport(result) {
        this.fragments = result.fragments;
        this.rapport = result.rapport;
        this.cdf.detectChanges()
        
        setTimeout(() => {
            let node = document.createElement('script');
            node.src = '/assets/main.js'
            node.type = 'text/javascript';
            node.id = this.nodeid;
            document.getElementsByTagName('head')[0].appendChild(node);
        }, 1000)
    }

    downloadRapport(type){
        window['tryga']('send', 'event', 'rapports', 'export_' + type, this.nameRapport, '');

        if(this.subscribe && this.subscribe['downloadrapport']){
            this.subscribe['downloadrapport'].unsubscribe();
        }
        //nom_prenom_client_type-rapport_date-generation
        let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"})
        this.name = this.dossier.nom+"_"+this.dossier.prenom+"_"+this.nameRapport+"_"+dategeneration+'.'+type.toLowerCase()
        this.name = this.name.replace(' ', '_')
        this.subscribe['downloadrapport'] = this.appService.downloadrapport(this.dossier.id,this.nameRapport, type).subscribe((res)=>{
            if(res){
                let aDownload = document.createElement('a')
                aDownload.download = this.name
                aDownload.href = URL.createObjectURL(res)
                document.body.appendChild(aDownload)
                aDownload.click()
                document.body.removeChild(aDownload)
            }else{
                this.messageError = "Une erreur est survenue lors de l'export du rapport.";
                setTimeout(()=>{this.messageError = ""}, 5000);
            }
            
        },err=>{
            this.messageError = "Une erreur est survenue lors de l'export du rapport.";
                setTimeout(()=>{this.messageError = ""}, 5000);
        })
    }

    analyseRapportClick(e){
        let element = e.target
        // cas de l'ouverture de la popup
        if (element.classList &&
            (element.classList.contains('bible-anchor'))
        ) {
            window['tryga']('send', 'event', 'rapports', 'bible_ouverture', element.getAttribute('data-ids'), ''); // #2235 GA sur les fragments de bible
            return
        }
        let btn = null
        let count = 3
        do {
            if (element.classList &&
                (element.classList.contains('btn-ajout') || element.classList.contains('btn-supp'))
            ) {
                btn = element
            }
            element = element.parentElement
            console.log(count)
        } while (btn == null && count-- > 0);
        if (!btn) {
            return
        }

        let action    = btn.classList.contains('btn-supp') ? 1 : 0
        let newFargs = btn.getAttribute('data-ids')
        if (newFargs.indexOf(',') > -1) {
            newFargs = newFargs.split(',')
        }
        else {
            newFargs = [newFargs]
        }
        newFargs.forEach((newFrag) => {
            if (action == 1) {
                if (this.fragments.indexOf(newFrag) > -1) {
                    delete this.fragments[this.fragments.indexOf(newFrag)];
                    window['tryga']('send', 'event', 'rapports', 'bible_deselection', newFrag, ''); // #2235 GA sur les fragments de bible
                }
            }
            else {
                if (this.fragments.indexOf(newFrag) == -1) {
                    this.fragments.push(newFrag)
                    window['tryga']('send', 'event', 'rapports', 'bible_selection', newFrag, ''); // #2235 GA sur les fragments de bible
                }
            }
        })
        this.fragments = this.fragments.filter(e=>e) // retirer les éléments vide
        this.appService.setBibleSnippet(this.dossier.id,this.nameRapport, this.fragments).subscribe((res)=>{
            console.log(res)
        })
    }
}